import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { CartContext } from "../context/cart"
import { CartTotal, Head, MegaMenuItemContainer, StyledLink } from "./header-styles"
import Logo from "../images/logo-resized.png"
import { ReactMegaMenu } from "./megamenu";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';


const Header = ({ siteTitle, subText }) => {
  const [cart, updateCart] = useContext(CartContext)
  const [cartCount, updateCartCount] = useState(0)

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });


  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    updateCartCount(cart.items.reduce((acc, next) => acc + next.quantity, 0))
  }, [cart])


  const BabyHampers = () => {
    return <MegaMenuItemContainer>
      <ul>
        <li className="item"><Link to="/unisex">Unisex Hampers</Link></li>
        <li className="item"><Link to="/boys">Baby Boy Hampers</Link></li>
        <li className="item"><Link to="/girls">Baby Girl Hampers</Link></li>
      </ul>
      <ul>
        {/* <li className="item"><Link to="/personalised-hampers">Personalised Hampers1</Link></li> */}
        <li className="item"><Link to="/letterbox-gifts">Letterbox Gifts</Link></li>
        <li className="item"><Link to="/eco-hampers">Eco Conscious Hampers</Link></li>
        <li className="item"><Link to="/suitcases">Suitcase Hampers</Link></li>
      </ul>
      <ul>
        <li className="item"><Link to="/bath-time-hampers">Bathtime Hampers</Link></li>
        <li className="item"><Link to="/new-parent-hampers">New Parent Hampers</Link></li>
        <li className="item"><Link to="/cosy-hampers">Cosy Hampers</Link></li>
      </ul>
    </MegaMenuItemContainer>;
  };

  const BabyGifts = () => {
    return <MegaMenuItemContainer>
      <ul>
        <li className="item"><Link to="/onesie-sets">Onesie Sets</Link></li>
        <li className="item"><Link to="/comforters">Comforters</Link></li>
        <li className="item"><Link to="/baby-accessories">Baby Accessories</Link></li>
      </ul>
      <ul>
        <li className="item"><Link to="/baby-toys">Baby Toys</Link></li>
        <li className="item"><Link to="/blankets">Blankets</Link></li>
        <li className="item"><Link to="/bathtime-accessories">Bathtime Accessories</Link></li>
      </ul>
      <ul>
        <li className="item"><Link to="/clothing">Clothing</Link></li>
      </ul>
    </MegaMenuItemContainer>;
  };

  const PersonalisedGifts = () => {
    return <MegaMenuItemContainer>
      <ul>
        <li className="item"><Link to="/personalised-blankets">Blankets</Link></li>
        <li className="item"><Link to="/personalised-bibs">Bibs</Link></li>
      </ul>
      <ul>
        <li className="item"><Link to="/personalised-comforters">Comforters</Link></li>
        <li className="item"><Link to="/personalised-accessories">Accessories</Link></li>
      </ul>
      <ul>
        <li className="item"><Link to="/personalised-clothing">Clothing</Link></li>
      </ul>
        

    </MegaMenuItemContainer>;
  };

  const items = [{
    label: "Best Sellers",
    key: "bestsellers",
    items: null,
    isLink: <Link to="/best-sellers">Best Sellers</Link>
  },
  {
    label: "New Arrivals",
    key: "new-arrivals",
    items: null,
    isLink: <Link to="/new-arrivals">New Arrivals</Link>
  },
  {
    label: "Baby Hampers",
    key: "baby-hampers",
    items: <BabyHampers />
  },
  {
    label: "Baby Gifts",
    key: "baby-gifts",
    items: <BabyGifts />
  },
  {
    label: "Spring/Summer",
    key: "spring-summer",
    items: null,
    isLink: <Link to="/spring-summer">Spring/Summer</Link>
  },
  // {
  //   label: "Winter Warmers",
  //   key: "winter-warmers",
  //   items: null,
  //   isLink: <Link to="/winter-warmers">Winter Warmers</Link>
  // },
  // {
  //   label: "Christmas",
  //   key: "christmas",
  //   items: null,
  //   isLink: <Link to="/christmas">Christmas 🎄</Link>
  // },
  {
    label: "Personalised Gifts",
    key: "personalised",
    items: <PersonalisedGifts />
  },
  // {
  //   label: "Build Your Own",
  //   key: "build",
  //   items: null,
  //   isLink: <Link to="/build">Build Your Own</Link>
  // },
  
];

const fullMenu = items.concat([{
  label: "Sale",
  key: "sale",
  items: null, 
  isLink: <Link to="/sale">Sale</Link>
},
{
  label: "Basket", 
  key: "basket", 
  items: null, 
  isLink: <>{cart.items.length > 0 ? <CartTotal>{cartCount}</CartTotal> : null}
  <Link to="/basket">Basket</Link></>
}]);

  const styleConf = {
    menuProps: {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center"
      }
    },
    contentProps: {
      style: {
        width: "100%",
        backgroundColor: "#cccccc40",
        padding: "10px",
        marginTop: "10px"        
      }
    },
    menuItemProps: {
      style: {
        display: "inline",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        fontSize: "13px",
        padding: "0 20px",
        borderLeft: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        position: "relative",
      }, 
      className: "parentMenuItem"
    },
    menuItemSelectedProps: {
      style: {
        display: "inline",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        fontSize: "13px",
        padding: "0 20px",
        borderLeft: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        position: "relative",
      }
    },
    containerProps: {
      style: {
        width: "90vw",
        marginTop: "0px",
        justifyContent: "center",
        alignItems: "center",
        borderTop: "1px solid #ccc",
        borderBottom: "1px solid #ccc",
        padding: "8px 0",
        position: "relative",
        display: "flex",
        flexDirection: "column"
      }, 
      className: "nav"
    }
  };

  const [isVisible, setIsVisible] = useState(items.map((i, ins) => {return {i: ins, visible: false}}));
  const toggleChildMenu = (index) => {
    console.log('toggle', index);
    let remap = isVisible.map((i, ins) => {return {i: i.ins, visible: (index === ins) ? !i.visible : false}});
    setIsVisible(remap);
  }

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {items.map((i, index) => (
          <ListItem key={i.label} disablePadding sx={{flexDirection: 'column'}}>
            <ListItemButton sx={{textTransform: "uppercase", fontSize: '13px'}}>
              {i.isLink ? i.isLink : <span style={{color: '#d96528'}} onClick={() => toggleChildMenu(index)}>{i.label}</span>}
            </ListItemButton>
            {i.items && isVisible[index].visible ? i.items : null}
          </ListItem>
        ))}
      </List>
    </Box>
  );


  const mobileStyle = Object.assign({}, styleConf.containerProps.style, { display: { xs: 'flex', sm: 'flex', md: 'none' } });

  return (
    <Head>
      <h1><Link to="/"><img src={Logo} alt={siteTitle} /></Link></h1>

      <Box sx={mobileStyle} className="nav" >

        <ul className={styleConf.menuProps.className} style={{padding: 0}}>
        {['Products'].map((a) => (
            <React.Fragment key={'left'}>
              <li style={styleConf.menuItemProps.style} className={styleConf.menuItemProps.className}>
              <span onClick={toggleDrawer('left', true)}>{a}</span>
              <Drawer
                anchor={'left'}
                open={state['left']}
                onClose={toggleDrawer('left', false)}
              >
                {list('left')}
              </Drawer>
              </li>
            </React.Fragment>
          ))}
          <li className={styleConf.menuItemProps.className} style={styleConf.menuItemProps.style}><Link to="/sale">Sale</Link></li>
          <li className={styleConf.menuItemProps.className} style={styleConf.menuItemProps.style}><>{cart.items.length > 0 ? <CartTotal>{cartCount}</CartTotal> : null}<Link to="/basket">Basket</Link></></li>
        </ul>
      </Box>

      <Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }} >
        <ReactMegaMenu
          tolerance={500}      // optional, defaults to 100
          direction={"RIGHT"}  // optional, defaults to "RIGHT", takes in "RIGHT" || "LEFT"
          styleConfig={ styleConf }   // defaults to an empty object. not recommended to be left blank.
          onExit={()=> console.log('leave') }  // a function to be called when a mouse leaves the container
          data={fullMenu}        // array of data to be rendered
        />
      </Box>
      

    </Head>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

export default Header
